import { ModulesMap } from '@/config/data/modulesMaps'
import WorksProductivityNormsApi from '@/services/apiServiceModules/worksProductivityNormsApi'
import DataTransferModule from '@/services/dataTransferModule'

const worksProductivityNormsApi = new WorksProductivityNormsApi()

export default class WorksProductivityNormsDt extends DataTransferModule {
	constructor() {
		super(ModulesMap.WORKS_PRODUCTIVITY_NORMS, worksProductivityNormsApi, {
			useCache: true,
		})
	}
}
